import styled, { css } from 'styled-components';

export const MainContainer = styled.div`
  max-width: 85%;
  margin: 2em auto;

  a {
    text-decoration: underline;
    color: blue;
  }
  @media (max-width: 720px) {
    max-width: 100%;
  }
`;

export const TriggerSpan = styled.span`
  position: relative;
  top: 3px;
  margin-left: 6px;
  @media (min-width: 720px) {
    cursor: pointer;
  }
`;
export const Container = styled.div`
  display: flex;
  padding: 0 6px;
  line-height: 22px;
`;
export const TriggerText = styled.span`
  margin-left: 18px;
  transition: all 0.18s ease;
  @media (max-width: 720px) {
    cursor: pointer;
  }
`;

export const FootNoteMain = styled.div`
  // padding: 3% 5%;
  display: flex;
  // background-color: #f5f5f5;
  @media (max-width: 720px) {
    display: block;
    padding: 30px 14px;
    margin-bottom: ${(props) => (props.margin ? '43px' : '')};
  }
`;
export const FootNoteFirstInner = styled.div`
  flex-basis: ${(props) => props.flexBasis};
`;
export const FootNoteSecInner = styled.div`
  flex-basis: ${(props) => props.flexBasis};
  padding-left: ${(props) => props.leftPadding};
  @media (max-width: 720px) {
    padding-left: 0px;
  }
`;
export const FootNoteNewStyle = styled.div`
  .tableHead {
    font-size: clamp(18px, 3vw, 20px);
    color: #777;
    padding: 10px 0;
    font-weight: 600;
  }
  h1,
  h2 {
    font-size: clamp(18px, 3vw, 20px);
    color: #777;
    padding: 10px 0;
  }
  h3 {
    font-size: clamp(14px, 3vw, 16px);
    color: #777;
    padding: 5px 0;

    ${(props) =>
      props.changeTag
        ? css`
            font-size: clamp(18px, 3vw, 20px);
            color: #777;
            padding: 10px 0;
          `
        : null}
  }
  h4 {
    font-size: clamp(14px, 3vw, 16px);
    color: #777;
    padding: 5px 0;
  }
  .ansText {
    font-size: clamp(12px, 3vw, 14px);
  }
  .questionName {
    font-size: clamp(14px, 3vw, 16px);
    font-weight: 600;
  }

  p {
    font-size: clamp(12px, 2vw, 14px);
    padding: 6px 0;
    a {
      color: blue;
      text-decoration: underline;
    }
  }
  li {
    font-size: clamp(12px, 2vw, 14px);
    padding: 6px 0;
    font-weight: bold;
    color: #000000ab;
    p {
      color: black;
      font-weight: 400;
    }
  }
  strong {
    color: #000000ab;
  }
  span {
    font-size: clamp(12px, 2vw, 14px);
  }

  ol {
    padding: 0 16px;
  }

  table {
    border: none;
    width: 100% !important;

    th {
      border: none;
      color: #777;
    }

    tr {
      border: none;
      display: flex;
      column-gap: 4px;
      justify-content: flex-start;
    }
    td {
      border: none !important;
      color: #777;
      padding: 10px 0;
      width: auto !important;
      height: auto !important;
      white-space: normal !important;
      transition: all 0.18s ease;
      display: flex;
      font-size: 12px;

      &:nth-child(1) {
        flex-basis: 75%;
      }

      &:nth-child(2) {
        flex-basis: 30%;
        justify-content: center;
      }
      &:nth-child(3) {
        flex-basis: 30%;
        justify-content: center;
      }
      &:nth-child(4) {
        flex-basis: 30%;
        justify-content: center;
      }

      @media (max-width: 720px) {
        padding: 10px 0;
      }

      a {
        text-decoration: none !important;
        color: inherit !important;
        font-size: clamp(10px, 2vw, 12px);
        &:hover {
          opacity: 0.8;
        }
      }
    }

    th {
      text-align: center;
      padding-bottom: 10px;
      font-size: 12px;
      &:nth-child(1) {
        flex-basis: 75%;
      }

      &:nth-child(2) {
        flex-basis: 30%;
      }
      &:nth-child(3) {
        flex-basis: 30%;
      }
      &:nth-child(4) {
        flex-basis: 30%;
      }
    }
  }
`;

export const PriceBoxStyle = styled.div`
  font-size: clamp(12px, 2vw, 14px);
  padding-bottom: 5%;
  border-bottom: solid 1px #dadada;
  p {
  }
  &:not(:first-child) {
    padding-top: 5%;
  }
  .headingSection {
    font-size: clamp(14px, 3vw, 16px);
    color: rgb(119, 119, 119);
    padding: 5px 0px;
    font-weight: bold;
  }
`;
export const FaqStyle = styled.div`
  padding-top: 5%;
`;

export const FootNote = styled.div``;
